module.exports = __webpack_public_path__ + "img/1526056088.59b451ea.jpg";